import React from "react";
import * as styles from "./DropDownFilter.module.scss";
import { DropDown } from "@silversea-ssc/ui-components-react";
import { useLingui } from "@lingui/react/macro";
import clsx from "clsx";

export interface DropDownFilterProps {
  label: string;
  children;
  selectedValuesLabel?: string;
  dataContentPiece?: string;
  disabled?: boolean;
  title?: string;
  className?: string;
  contentWrapperClassName?: string;
  variant?: "dark" | "default";
}

const DropDownFilter: React.FC<
  React.PropsWithChildren<DropDownFilterProps>
> = ({
  label,
  title,
  children,
  dataContentPiece = null,
  disabled = false,
  selectedValuesLabel,
  className,
  contentWrapperClassName,
  variant = "default"
}) => {
  const { t } = useLingui();
  return (
    <div data-content-piece={dataContentPiece}>
      <DropDown
        disabled={disabled}
        label={label}
        selectedValuesLabel={selectedValuesLabel}
        expandOnMobile="absolute"
        expandOnTablet="absolute"
        expandOnDesktop="absolute"
        closeOnClickOutside={true}
        closeButtonLabel={t({ id: `Modal close button label` })}
        size="big"
        className={className}
        contentWrapperClassName={clsx(
          styles.contentWrapper,
          contentWrapperClassName
        )}
        variant={variant}
      >
        {title && (
          <div
            className={clsx(
              styles.title,
              variant == "dark" && styles.invertedTitle
            )}
          >
            {title}
          </div>
        )}
        {children}
      </DropDown>
    </div>
  );
};

export default React.memo(DropDownFilter);
